import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core";
import {
	BorderDialog,
	DialogWrapBody,
	DialogWrapClose,
	DialogWrapCloseBtn,
	DialogWrapFoot,
	DialogWrapFootBtn,
	DialogWrapHeading,
	DialogWrapImg,
	DialogWrapTitle,
	DialogWrapTitleInner,
	StyledDialogWrap,
	StyleDialogContent,
	StyleDialogTitle,
} from "./StyledDialogWrap";
import { FlattenSimpleInterpolation } from "styled-components";

const useStyles = makeStyles({
	paper: {
		minWidth: "1200px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px",
	},
	footer: {
		padding: "0px",
	},
});

const useStyleMedium = makeStyles({
	paper: {
		minWidth: "600px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
			margin: "16px",
			width: "100%",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px",
	},
	footer: {
		padding: "0px",
	},
});

const useStyleMediumFilter = makeStyles({
	paper: {
		minWidth: "900px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
			margin: "16px",
			width: "100%",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px",
	},
	footer: {
		padding: "0px",
	},
});
const useStyleMediumv2 = makeStyles({
	paper: {
		width: "max-content;",
		display: "block",
		borderRadius: "16px",
		maxWidth: "unset",
		"@media(max-width: 768px)": {
			minWidth: "unset",
			margin: "16px",
			width: "100%",
			maxWidth: "450px",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px",
	},
	footer: {
		padding: "0px",
	},
});
const useStyleMediumBank = makeStyles({
	paper: {
		width: "432px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
			margin: "16px",
			width: "100%",
			maxWidth: "450px",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0",
	},
	footer: {
		padding: "0px",
	},
});

// Full-screen = fill the viewport and wire a proper flex height chain so the
// builder's three panes (palette / canvas / inspector) each scroll independently.
//
// Height chain:
//   MUI paper (100vh, flex-column)
//   → StyleDialogTitle   (flex-shrink:0)
//   → StyleDialogContent (flex:1, display:flex-column via body class below)
//   → DialogWrapBody     (flex:1, display:flex via & > * below)
//   → StyledUpdateContentWrap (flex:1, min-height:0 — set in StyleEmailFormat)
//   → ShellWrap          (height:100%, min-height:0 — already set)
//   → PaneRow            (flex:1, overflow:hidden — already set)
//   → SidePanel / CanvasArea  (overflow-y:auto — each scrolls independently)
//
// NOTE: we intentionally do NOT set overflow:hidden on DialogWrapBody — that
// would clip drag-ghost elements during block drag-and-drop inside the canvas.
// The only scroll containers are CanvasArea + the two SidePanel panes.
export const useStyleFullScreen = makeStyles({
	paper: {
		width: "100vw",
		height: "100vh",
		maxWidth: "unset",
		maxHeight: "unset",
		minWidth: "unset",
		margin: 0,
		borderRadius: 0,
		"@media(max-width: 768px)": {
			minWidth: "unset",
		},
	},
	heading: {
		padding: "0px",
	},
	// Override MUI DialogContent: switch from single-scroll-container to a flex
	// column that passes height down to the builder shell. We keep overflow-y:auto
	// (MUI default) intact — with min-height:0 at every flex level, the builder
	// panes size to available space and scroll internally, so DialogContent itself
	// never overflows. For non-builder editor modes (HTML/Easy) the single
	// DialogContent scroll continues to work normally.
	body: {
		padding: "0px",
		display: "flex",
		flexDirection: "column",
		// Make DialogWrapBody (the direct child block div) inherit the flex geometry
		// so ShellWrap's height:100% has a real ancestor height to resolve against.
		// We do NOT zero out padding — DialogWrapBody's own padding (20px horizontal)
		// is needed for the subject row and template-name field above the builder.
		"& > *": {
			flex: "1 1 auto",
			display: "flex",
			flexDirection: "column",
			minHeight: 0,
		},
	},
	footer: {
		padding: "0px",
	},
});

export const useStyleSmall = makeStyles({
	paper: {
		width: "400px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px !important",
	},
	footer: {
		padding: "0px",
	},
});

export const useStyleSmallTransaction = makeStyles({
	paper: {
		width: "400px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px !important",
		minWidth: "300px",
	},
	footer: {
		padding: "0px",
	},
});

const useStyleLogin = makeStyles({
	paper: {
		minWidth: "500px",
		display: "block",
		borderRadius: "16px",
		"@media(max-width: 768px)": {
			minWidth: "unset",
			margin: "16px",
			width: "100%",
		},
	},
	heading: {
		padding: "0px",
	},
	body: {
		padding: "0px",
	},
	footer: {
		padding: "0px",
	},
});

export type DialogWrapType = {
	children: JSX.Element | JSX.Element[] | string | string[] | null;
	open: boolean;
	onClose: (e: any, reason: any) => void;
	className?: string;
	title?: string;
	srcImg?: string;
	text?: string;
	actions?: JSX.Element | string;
	useCustomStyles?: () => any;
	hideHeader?: boolean;
	hideFooter?: boolean;
	medium?: boolean;
	xStyleHeading?: FlattenSimpleInterpolation;
	xStyleTitle?: FlattenSimpleInterpolation;
	xStyleClose?: FlattenSimpleInterpolation;
	xStyleBody?: FlattenSimpleInterpolation;
	xStyleFooter?: FlattenSimpleInterpolation;
	xStyleBorder?: FlattenSimpleInterpolation;
	disableEnforceFocus?: boolean;
	disableAutoFocus?: boolean;
	disableRestoreFocus?: boolean;
	hideClose?: boolean;
	center?: boolean;
	login?: boolean;
};

export default function DialogWrap(props: DialogWrapType) {
	const styles = (props.useCustomStyles && props.useCustomStyles()) || useStyles();

	return (
		<StyledDialogWrap
			disableAutoFocus={props.disableAutoFocus}
			disableEnforceFocus={props.disableEnforceFocus}
			disableRestoreFocus={props.disableRestoreFocus}
			open={props.open}
			onClose={props.onClose}
			classes={{ paper: styles.paper }}
			className={props.className}
			$xStyle={props.xStyleBorder}>
			{!props.hideHeader && (
				<StyleDialogTitle className={styles.heading}>
					<DialogWrapHeading
						medium={props.medium}
						login={props.login}
						xStyle={props.xStyleHeading}>
						<DialogWrapTitle
							medium={props.medium}
							xStyle={props.xStyleTitle}>
							{props.srcImg && <DialogWrapImg src={props.srcImg}></DialogWrapImg>}

							<DialogWrapTitleInner center={props.center}>{props.title || "--"}</DialogWrapTitleInner>
						</DialogWrapTitle>
						{!props.hideClose && (
							<DialogWrapClose
								medium={props.medium}
								xStyle={props.xStyleClose}>
								<DialogWrapCloseBtn onClick={() => props.onClose(null, null)}>
									<i className="material-icons">close</i>
								</DialogWrapCloseBtn>
							</DialogWrapClose>
						)}
					</DialogWrapHeading>
				</StyleDialogTitle>
			)}

			<StyleDialogContent className={styles.body}>
				<DialogWrapBody
					login={props.login}
					medium={props.medium}
					xStyle={props.xStyleBody}
					center={props.center}>
					{props.children || (props.text && <div>{props.text}</div>) || null}
				</DialogWrapBody>
			</StyleDialogContent>

			{!props.hideFooter && (
				<DialogActions className={styles.footer}>
					<DialogWrapFoot
						medium={props.medium}
						xStyle={props.xStyleFooter}>
						{props.actions || (
							<DialogWrapFootBtn onClick={() => props.onClose(null, null)}>Cancel</DialogWrapFootBtn>
						)}
					</DialogWrapFoot>
				</DialogActions>
			)}
		</StyledDialogWrap>
	);
}

export function DialogWrapMedium(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleMedium}
		/>
	);
}

export function DialogWrapSmall(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleSmall}
		/>
	);
}

export function DialogWrapMediumBankInFinancial(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleMediumv2}
		/>
	);
}
export function DialogWrapMediumBank(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleMediumBank}
		/>
	);
}
export function DialogWrapAddUser(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyles}
		/>
	);
}

export function DialogWrapAddress(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleMedium}
		/>
	);
}
export function DialogWrapSmallTransaction(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleSmallTransaction}
		/>
	);
}

export function DialogWrapMediumFilter(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleMediumFilter}
		/>
	);
}

export function DialogWrapLogin(props: DialogWrapType) {
	return (
		<DialogWrap
			{...props}
			medium={true}
			useCustomStyles={useStyleLogin}
		/>
	);
}
